export default __webpack_public_path__ + "static/media/screen4.e4a7205b.png";